<script>
export default { name: 'BrainRouteView' };
</script>

<template>
  <router-view />
</template>
